/**
 * @file shop-card-tabs.ts
 * @description Вкладки карточки магазина (phase19.28 этап А;
 * uiux-platform-shops §1, §7 «Права»): реестр вкладок с правами —
 * «Интеграции» видна только с `PLATFORM_MANAGE_INTEGRATIONS`, «Доступ» —
 * с `PLATFORM_MANAGE_USERS`. Новая вкладка = запись, а не ветка в разметке.
 */

export type ShopTab = "overview" | "domains" | "integrations" | "access";

interface ShopTabMeta {
  value: ShopTab;
  label: string;
  /** Право на вкладку; нет — видна всем, у кого есть раздел. */
  permission?: string;
}

export const SHOP_TABS: readonly ShopTabMeta[] = [
  { value: "overview", label: "Обзор" },
  { value: "domains", label: "Домены" },
  { value: "integrations", label: "Интеграции", permission: "PLATFORM_MANAGE_INTEGRATIONS" },
  { value: "access", label: "Доступ", permission: "PLATFORM_MANAGE_USERS" },
];

/** Вкладка по адресу `/platform/shops/<id>/<tab>`; неизвестная — «Обзор». */
export function tabFromPath(pathname: string): ShopTab {
  const last = pathname.replace(/\/+$/, "").split("/").pop() ?? "";
  return SHOP_TABS.some((tab) => tab.value === last) ? (last as ShopTab) : "overview";
}

/** Вкладки, доступные по правам активного кабинета. */
export function visibleTabs(permissions: readonly string[]): ShopTabMeta[] {
  return SHOP_TABS.filter((tab) => !tab.permission || permissions.includes(tab.permission));
}
